jQuery(document).ready(function($) {

    var burgerIcon = $('.hamburger-main-menu');
    var searchButton = $('.search-button');
    var searchButtonLabel = searchButton.children('.menu-trigger');
    var searchIcon = $('.header-search-icon');
    var searchCrossIcon = $('.hamburger-search');

    var megaMenu = $('#mega-menu');
    var megaSearch = $('#mega-search');

    var fadeInContent = $('.mega-menu .animate-fade-in');
    var logo = $('.logo-wrapper');
    var logoImg = $('.logo');

    var valuationBtnMobile = $('.valuation-btn-mobile');
    var filterBtn = $('#filter-btn');
    var filtersMenuFilters = $('.filters-menu-filters');

    var replaceLogoBtn = $('.replace-logo-scroll');

    var backToResultsBtn = $('.property-hero-back-btn');

    var header = $('.header');
    var lastScrollY = window.scrollY || window.pageYOffset || 0;
    var menuTriggers = $('.menu-trigger');
    var desktopHeader26Menus = $('.header-26-menu');
    var desktopHeader26MenuItems = $('.header-26-menu > ul > li');
    var mobileHeader26MenuItems = $('#mega-menu .header-26-menu-list > li');
    var header26MenuItems = desktopHeader26MenuItems.add(mobileHeader26MenuItems);
    var header26MegaPanels = header26MenuItems.children('.mega');
    var closeHeader26MegaTimeout = null;

    function isDesktopHeader() {
        return window.matchMedia('(min-width: 1200px)').matches;
    }

    function clearHeader26MegaCloseTimeout() {
        window.clearTimeout(closeHeader26MegaTimeout);
    }

    function getActiveHeader26MenuItem() {
        return header26MenuItems.filter('.is-active')[0];
    }

    function openHeader26Mega(menuItem) {
        clearHeader26MegaCloseTimeout();

        header26MenuItems
            .not(menuItem)
            .removeClass('is-active')
            .children('.menu-trigger')
            .attr('aria-expanded', 'false');

        $(menuItem)
            .addClass('is-active')
            .children('.menu-trigger')
            .attr('aria-expanded', 'true');
    }

    function closeHeader26Mega() {
        header26MenuItems
            .removeClass('is-active')
            .children('.menu-trigger')
            .attr('aria-expanded', 'false');
    }

    function toggleMobileHeader26Mega(menuItem) {
        var isActive = $(menuItem).hasClass('is-active');

        closeHeader26Mega();

        if (!isActive) {
            $(menuItem)
                .addClass('is-active')
                .children('.menu-trigger')
                .attr('aria-expanded', 'true');
        }

        scrollMobileHeader26MenuItemIntoView(menuItem);
    }

    function scrollMobileHeader26MenuItemIntoView(menuItem) {
        var scrollContainer = megaMenu[0];
        var item = $(menuItem)[0];

        if (!scrollContainer || !item || isDesktopHeader()) {
            return;
        }

        window.setTimeout(function() {
            var containerTop = scrollContainer.getBoundingClientRect().top;
            var itemTop = item.getBoundingClientRect().top;
            var scrollTop = scrollContainer.scrollTop + itemTop - containerTop - 24;

            scrollContainer.scrollTo({
                top: Math.max(scrollTop, 0),
                behavior: 'smooth'
            });
        }, 300);
    }

    function isSearchOpen() {
        return megaSearch.hasClass('is-active');
    }

    function isMenuOpen() {
        return burgerIcon.hasClass('is-active');
    }

    function focusSearchInput() {
        window.setTimeout(function() {
            megaSearch.find('.location-input').first().trigger('focus');
        }, 0);
    }

    function setMenuTriggersHidden(isHidden) {
        menuTriggers
            .toggleClass('hidden', isHidden)
            .prop('disabled', isHidden);
    }

    function queueHeader26MegaClose() {
        clearHeader26MegaCloseTimeout();

        closeHeader26MegaTimeout = window.setTimeout(function() {
            var activeMenuItem = getActiveHeader26MenuItem();

            if (!activeMenuItem) {
                return;
            }

            if (
                desktopHeader26Menus.is(':hover') ||
                $(activeMenuItem).children('.mega').is(':hover') ||
                $.contains(activeMenuItem, document.activeElement)
            ) {
                return;
            }

            closeHeader26Mega();
        }, 180);
    }

    function closeHeader26MegaWhenPointerLeavesPanel(event) {
        if (!isDesktopHeader()) {
            return;
        }

        var activeMenuItem = getActiveHeader26MenuItem();

        if (!activeMenuItem) {
            return;
        }

        var activeMega = $(activeMenuItem).children('.mega')[0];

        if (!activeMega) {
            return;
        }

        if (
            $.contains(activeMenuItem, event.target) ||
            $.contains(activeMega, event.target) ||
            activeMega === event.target
        ) {
            return;
        }

        if (event.clientY > activeMega.getBoundingClientRect().bottom) {
            closeHeader26Mega();
        }
    }

    $('.mega-menu-nav .hdln-4').on('click', function() {
        if ($(window).width() > 575) {
            return;
        }

        var menuContainer = $(this).next('ul');

        if (!menuContainer.is(':visible')) {
            $('.mega-menu-nav ul').slideUp();
            $('.mega-menu-nav .hdln-4').removeClass('active');

            menuContainer.slideDown();
            $(this).addClass('active');
        } else {
            menuContainer.slideUp();
            $(this).removeClass('active');
        }
    });

    desktopHeader26MenuItems.on('mouseenter focusin', function() {
        if (!isDesktopHeader()) {
            return;
        }

        openHeader26Mega(this);
    });

    desktopHeader26Menus.on('mouseenter', function() {
        clearHeader26MegaCloseTimeout();
    });

    desktopHeader26Menus.on('mouseleave', queueHeader26MegaClose);

    header26MegaPanels.on('mouseenter', function() {
        clearHeader26MegaCloseTimeout();
    });

    header26MegaPanels.on('mouseleave', queueHeader26MegaClose);

    desktopHeader26MenuItems.on('focusout', function() {
        queueHeader26MegaClose();
    });

    mobileHeader26MenuItems.children('.menu-trigger').on('click', function(event) {
        if (isDesktopHeader()) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        toggleMobileHeader26Mega($(this).parent());
    });

    $(document).on('mousemove', closeHeader26MegaWhenPointerLeavesPanel);

    function openMenu() {
        closeHeader26Mega();
        setHeaderHidden(false);
        burgerIcon.addClass('is-active');
        megaMenu.addClass('is-active');
        searchIcon.css('opacity', 1);
        // searchIcon.addClass('white');
        fadeInContent.addClass('is-active');
        logo.addClass('invisible');
        header.addClass('mega-menu-open');
        valuationBtnMobile.addClass('invisible');
    }

    function closeMenu() {
        closeHeader26Mega();
        burgerIcon.removeClass('is-active');
        megaMenu.removeClass('is-active');
        searchIcon.css('opacity', 1);
        // searchIcon.removeClass('white');
        fadeInContent.removeClass('is-active');
        logo.removeClass('invisible');
        header.removeClass('mega-menu-open');
        valuationBtnMobile.removeClass('invisible');
    }

    function openSearch() {
        closeHeader26Mega();
        setHeaderHidden(false);
        // setMenuTriggersHidden(true);
        searchIcon.addClass('is-active');
        megaSearch.addClass('is-active');
        burgerIcon.css('opacity', 0);
        // searchCrossIcon.addClass('is-light');
        // logo.addClass('invisible');
        searchButtonLabel.text('Close');
        searchCrossIcon.show();
        searchIcon.hide();
        header.addClass('mega-menu-open');
        fadeInContent.addClass('is-active');
        valuationBtnMobile.addClass('invisible');
        focusSearchInput();
    }

    function closeSearch() {
        // setMenuTriggersHidden(false);
        searchIcon.removeClass('is-active');
        megaSearch.removeClass('is-active');
        burgerIcon.css('opacity', 1);
        // searchCrossIcon.removeClass('is-light');
        // logo.removeClass('invisible');
        searchButtonLabel.text('Search');
        searchCrossIcon.hide();
        searchIcon.show();
        header.removeClass('mega-menu-open');
        fadeInContent.removeClass('is-active');
        valuationBtnMobile.removeClass('invisible');
    }

    function toggleSearch(event) {
        event.stopPropagation();

        if (isSearchOpen()) {
            closeSearch();
        } else {
            closeMenu();
            openSearch();
        }
    }

    function setHeaderScrolled(isScrolled) {
        if (header.hasClass('has-scrolled') === isScrolled) {
            return;
        }

        header.toggleClass('has-scrolled', isScrolled);
        filterBtn.toggleClass('has-scrolled', isScrolled);
        replaceLogoBtn.toggleClass('has-scrolled', isScrolled);
        // logoImg.toggleClass('invisible', isScrolled);
    }

    function setHeaderHidden(isHidden) {
        header.toggleClass('is-hidden', isHidden);
        filtersMenuFilters.toggleClass('has-scrolled', isHidden);
        backToResultsBtn.toggleClass('has-scrolled', isHidden);
    }

    burgerIcon.on('click', function(event) {
        event.stopPropagation();

        if (isMenuOpen()) {
            closeMenu();
        } else {
            closeSearch();
            openMenu();
        }
    });

    searchButton.on('click', toggleSearch);
    searchCrossIcon.on('click', toggleSearch);

    $(document).on('click', 'a[href*="trigger-search"], .trigger-search, [data-trigger-search]', function(event) {
        event.preventDefault();
        event.stopPropagation();

        closeMenu();
        openSearch();
    });

    $(document).on('click', function(event) {
        if (isMenuOpen()) {
            if (!$(event.target).closest('#mega-menu').length && !$(event.target).is('.hamburger-main-menu')) {
                closeMenu();
            }
        }

        if (isSearchOpen()) {
            if (!$(event.target).closest('#mega-search, .ui-autocomplete').length && !$(event.target).closest('.search-button').length) {
                closeSearch();
            }
        }
    });

    function handleScroll() {
        var scrollPointElement = document.getElementById('scrollPoint');
        var currentScrollY = window.scrollY || window.pageYOffset || 0;
        var scrollPoint = scrollPointElement ? scrollPointElement.getBoundingClientRect().top + currentScrollY : 0;
        var scrollDifference = currentScrollY - lastScrollY;
        var hasScrolledPastPoint = currentScrollY > scrollPoint;
        var isScrollingDown = scrollDifference > 4;
        var isScrollingUp = scrollDifference < -4;

        setHeaderScrolled(hasScrolledPastPoint);

        if (!isMenuOpen() && !isSearchOpen()) {
            if (hasScrolledPastPoint && isScrollingDown) {
                setHeaderHidden(true);
                valuationBtnMobile.addClass('has-scrolled');
            } else if (!hasScrolledPastPoint || isScrollingUp) {
                setHeaderHidden(false);
                valuationBtnMobile.removeClass('has-scrolled');
            }
        }

        lastScrollY = currentScrollY;
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll();

});
